export const ILLUSTS_PER_PAGE = 20
export const MESSAGES_PER_PAGE = 40
